import { profile as profileEn } from "./profile-en";
import { profile as profilePt } from "./profile-pt";

export const profiles = {
  en: profileEn,
  pt: profilePt,
};

export const getProfileByLocale = (locale = "en") => {
  const normalized = (locale || "en").toLowerCase();
  if (normalized.startsWith("pt")) return profilePt;
  return profileEn;
};

export const profile = profileEn;
export default profile;
